import React, { useEffect, useState } from "react";
import { Space, Spin, Row, Col, Table } from "antd";
import {
  ArrowTrendingUpIcon,
  ShoppingCartOutlined,
  ChartPieIcon,
  CurrencyDollarIcon,
  HomeIcon,
  PresentationChartLineIcon,
  ShoppingCartIcon,
} from "@heroicons/react/24/outline";
import config from "../config";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import UsersChart from "./UsersChart";
import { DollarCircleOutlined } from "@ant-design/icons";
import users from "../assets/images/users.svg";
import totalRevenue from "../assets/images/TotalRevenue.svg";
import clalanderRevenue from "../assets/images/clalanderRevenue.svg";
import subscription from "../assets/images/subscription.svg";
import SubscriptionChart from "./SubscriptionChart";
import SubscriptionRateChart from "./SubscriptionRateChart";
import { Link } from "react-router-dom";
function Admin() {
  const AccessKey = localStorage.getItem("AdminAccessKey");
  const UserID = localStorage.getItem("AdminID");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  let navigate = useNavigate();

  useEffect(() => {
    document.title = "Fuelbook Admin Dashboard";
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: "Admin",
    };

    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/GetMainDashboard",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        
        if (response.data.status_code == 1) {
          setData(response.data);
          setLoading(false);
        } else if ( response.data.status_code === 0 ||response.data.status_code === 2) {
          navigate("/controlbase/login");
        } else if (response.data.status_message === "Invalid Access Key.") {
          navigate("/controlbase/login");
        } else {
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const NewUsers = [
    {
      title: "SR",
      dataIndex: "Sr",
      render: (_, record, index) => index + 1,
    },
    {
      title: "ID",
      dataIndex: "ID",
      key: "ID",
    },
    {
      title: "Dated",
      dataIndex: "Created_Date",
      key: "dated",
      render: (_, record) =>
        dayjs(record.Created_Date).format(config.date_format),
    },
    {
      title: "Pump Code",
      dataIndex: "PumpCode",
      key: "PumpCode",
      render:(_,record)=>
        <NavLink to={`/controlbase/petrolpump/detail/${record.ID}`} target="_blank">
          {record.PumpCode}
        </NavLink>
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render:(_,record)=>
        <NavLink to={`/controlbase/petrolpump/detail/${record.ID}`} target="_blank">
          {record.Name}
        </NavLink>
    },

    {
      title: "Phone",
      dataIndex: "Phone",
      key: "Phone",
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      key: "mobile",
    },

    {
      title: "Type",
      dataIndex: "PackageName",
      key: "type",
      align: "center",
      render: (text, record) => {
        if (record.PackageName == "Trial") {
          return (
            <div
              style={{
                backgroundColor: "#EF476F33",
                color: "#EF476F",
                borderRadius: "20px",
                textAlign: "center",
              }}
            >
              {text}
            </div>
          );
        } else {
          return text;
        }
      },
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "action",
    },
  ];
  const columns = [
    {
      title: "SR",
      dataIndex: "Sr",
      key: "Sr",
      render: (_, record, index) => index + 1,
    },
    {
      title: "ID",
      dataIndex: "ID",
      key: "ID",
    },
    {
      title: "Dated",
      dataIndex: "Created_Date",
      key: "dated",
      render: (date) => dayjs(date).format(config.date_format),
    },
    {
      title: "Pump Code",
      dataIndex: "PumpCode",
      key: "Pump_Code",
      render:(_,record)=>
        <NavLink to={`/controlbase/petrolpump/detail/${record.ID}`} target="_blank">
          {record.PumpCode}
        </NavLink>
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render:(_,record)=>
        <NavLink to={`/controlbase/petrolpump/detail/${record.ID}`} target="_blank">
          {record.Name}
        </NavLink>
    },

    {
      title: "Phone",
      dataIndex: "Phone",
      key: "phone",
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      key: "mobile",
    },

    {
      title: "Type",
      dataIndex: "PackageName",
      key: "type",
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "action",
    },
  ];

  return (
    <>
      <div className="right-side-contents">
        {loading ? (
          <div className="spin-center">
            <Space size="large">
              <Spin size="large" />
            </Space>
          </div>
        ) : (
          <div className="page-content control-base-wrap">
            <div className="page-header">
              <h3 className="page-title">Admin Dashboard</h3>
            </div>

            <Row gutter={[16, 16]}>
              <Col xs={24} md={8}>
                <div className="fb-card">
                  <div className="fb-card-header">
                    <div className="fb-card-title">
                      <span>
                        <img src={users} className="img-icon" alt="" />
                      </span>
                      <h4>Overview</h4>
                    </div>
                  </div>
                  <div className="fb-card-body">
                    <UsersChart
                      ActiveUsers={data.totalUsers}
                      TotalUsers={data.activeUsers}
                    />
                  </div>

                  <div className="subscription-chart-wrap">
                    <ul className="subscription-list">
                      <li>
                        <div className="sub-content">
                          <p>Monthly Package </p>
                          <b>{data.monthlyPackages}</b>
                        </div>
                        <div className="sub-mon"></div>
                      </li>
                      <li>
                        <div className="sub-content">
                          <p>6-Month Package </p>
                          <span>{data.sixMonthlyPackages}</span>
                        </div>
                        <div className="sub-6-mon"></div>
                      </li>
                      <li>
                        <div className="sub-content">
                          <p>Yearly Package </p>
                          <b>{data.yearlyPackages}</b>
                        </div>
                        <div className="sub-year"></div>
                      </li>
                      <li>
                        <div className="sub-content">
                          <p>Lifetime Package </p>
                          <b>{data.lifetimePackages}</b>
                        </div>
                        <div className="sub-life-time"></div>
                      </li>
                    </ul>
                  </div>

                  {/* <SaleChart /> */}
                </div>
              </Col>
              <Col xs={24} md={16}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={12}>
                  <Link to={`/controlbase/petrolpump/subscriptions/`}>
                    <div className="border-card purpole">
                      <div className="card-head">
                        <span>
                          <img src={totalRevenue} className="img-icon" alt="" />
                        </span>
                        <span>Total Revenue</span>
                      </div>
                      <div className="card-content">
                        <p>
                          <span>Rs.</span>&nbsp;{data.revenueTotal}
                        </p>
                      </div>
                    </div>
                    </Link>
                  </Col>
                  <Col xs={24} md={12}>
                  <Link to={`/controlbase/petrolpump/subscriptions/`}>
                    <div className="border-card orange">
                      <div className="card-head">
                        <span>
                          <img
                            src={clalanderRevenue}
                            className="img-icon"
                            alt=""
                          />
                        </span>
                        <span>Monthly Revenue</span>
                      </div>
                      <div className="card-content">
                        <p>
                          <span>Rs.</span>&nbsp;{data.revenueThisMonth}
                        </p>
                      </div>
                    </div>
                    </Link>
                  </Col>
                  <Col xs={24} md={24}>
                    <div className="fb-card">
                      <div className="fb-card-header">
                        <div className="fb-card-title">
                          <span>
                            <img
                              src={subscription}
                              className="img-icon"
                              alt=""
                            />
                          </span>
                          <h4>Subscription Insights</h4>
                        </div>
                      </div>
                      <ul className="subscription">
                        <li>
                          <SubscriptionChart />
                          <div className="sub-content">
                            <p>Retention rate</p>
                            <h6>{data.subscriptionRetentionRate}%</h6>
                          </div>
                        </li>
                        <li>
                          <SubscriptionRateChart />
                          <div className="sub-content">
                            <p>Account Drop rate</p>
                            <h6>{data.subscriptionDropRate}%</h6>
                          </div>
                        </li>
                        <li>
                          <div className="sub-content">
                            <p>Top Plan</p>
                            <h6>{data.topPerformingPlan}</h6>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <h4>New Users (Current Month)</h4>
            <Table
              size="small"
              scroll={{
                x: "100%",
              }}
              loading={loading}
              dataSource={data.NewCompanies}
              columns={NewUsers}
              pagination={false}
              bordered
            />
            <h4>Suspended or Deactivated Accounts:</h4>
            <div style={{ marginBottom: "50px" }}>
              <Table
                size="small"
                scroll={{
                  x: "100%",
                }}
                dataSource={data.SuspendedCompanies}
                loading={loading}
                columns={columns}
                pagination={false}
                bordered
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Admin;
